export const ASSETS = {
  "animations": {
    "education_correct_a_plus": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/education/a_plus.png",
      "width": 250,
      "height": 250,
      "transparent": true
    },
    "education_correct_graduation_hat": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/education/graduation_hat.png",
      "width": 300,
      "height": 300,
      "transparent": true
    },
    "education_incorrect_failed_exam": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/education/failed_exam.png",
      "width": 300,
      "height": 250,
      "transparent": true
    },
    "fantasy_correct_magic_spell": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/fantasy/magic_spell.png",
      "width": 350,
      "height": 350,
      "transparent": true
    },
    "fantasy_correct_sword_slash": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/fantasy/sword_slash.png",
      "width": 400,
      "height": 200,
      "transparent": true
    },
    "fantasy_incorrect_monster_hit": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/fantasy/monster_hit.png",
      "width": 300,
      "height": 300,
      "transparent": true
    },
    "military_correct_jet_flyby": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/military/jet_flyby.png",
      "width": 400,
      "height": 200,
      "transparent": true
    },
    "military_correct_tank_assault": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/military/tank_assault.png",
      "width": 350,
      "height": 250,
      "transparent": true
    },
    "military_incorrect_explosion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/animations/military/explosion.png",
      "width": 300,
      "height": 300,
      "transparent": true
    }
  },
  "backgrounds": {
    "main": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/main/preview/assets/backgrounds/abstract-bg.png",
      "width": 1920,
      "height": 1080,
      "transparent": false
    },
    "military_bg": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/2f1f3f23be6c495ea93a9fd7e27aa22d/preview/assets/backgrounds/military-bg.png",
      "width": 1920,
      "height": 1080,
      "transparent": false
    },
    "education_bg": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/2f1f3f23be6c495ea93a9fd7e27aa22d/preview/assets/backgrounds/education-bg.png",
      "width": 1920,
      "height": 1080,
      "transparent": false
    },
    "fantasy_bg": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/2f1f3f23be6c495ea93a9fd7e27aa22d/preview/assets/backgrounds/fantasy-bg.png",
      "width": 1920,
      "height": 1080,
      "transparent": false
    }
  },
  "sounds": {
    "epic_orchestral": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/epic_orchestral.ogg"
    },
    "electronic_beats": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/electronic_beats.ogg"
    },
    "ambient_focus": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/ambient_focus.ogg"
    },
    "correct_answer": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/correct_answer.ogg"
    },
    "incorrect_answer": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/incorrect_answer.ogg"
    },
    "combo_sound": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/combo_sound.ogg"
    },
    "time_freeze": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/time_freeze.ogg"
    },
    "power_up": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/power_up.ogg"
    },
    "skip_sound": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/skip_sound.ogg"
    },
    "game_over_music": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4ed83191756e4830b999340a0a36804f/bc21bb3e165848388e33c8c7a75778ee/preview/assets/sounds/game_over_music.ogg"
    }
  }
}
